<div class="row" [ngClass]="{'gipant-mode': giPantMode, 'henterpant-mode': henterPantMode}">
  <div class="col-12">
    <h3 class="title">{{'HOW_WORKS.TITLE' | translate}}</h3>
  </div>

  <div class="col-wrap" [ngClass]="{'col-lg-6 col-12 with-image': giPantMode, 'col-lg-4 col-12': henterPantMode}">
    <div class="image-wrap" *ngIf="giPantMode">
      <img ngSrc="../../../assets/images/screen-hw.png" width="238" height="388" loading="lazy" alt="screen app">
    </div>
    <div class="step-wrap step-1">
      <div class="number"><span>01</span></div>
      <h3 class="sub-title" *ngIf="giPantMode"><i class="icon custom-pl-love"></i>{{'HOW_WORKS.GIPANT.END_CONSUMER' | translate}}</h3>
      <h3 class="sub-title" *ngIf="henterPantMode"><i class="icon custom-pl-love"></i>{{'HOW_WORKS.HENTERPANT.END_CONSUMER' | translate}}</h3>
      <p *ngIf="giPantMode" [innerHTML]="'HOW_WORKS.GIPANT.END_CONSUMER_DESC' | translate"></p>
      <p *ngIf="henterPantMode" [innerHTML]="'HOW_WORKS.HENTERPANT.END_CONSUMER_DESC' | translate"></p>
    </div>
  </div>
  <div class="col-wrap" [ngClass]="{'col-lg-3 col-12': giPantMode, 'col-lg-4 col-12': henterPantMode}">
    <div class="step-wrap step-2">
      <div class="number"><span>02</span></div>
      <h3 class="sub-title" *ngIf="giPantMode"><i class="icon custom-mood-smile"></i>{{'HOW_WORKS.GIPANT.PLAYER' | translate}}</h3>
      <h3 class="sub-title" *ngIf="henterPantMode"><i class="icon custom-mood-smile"></i>{{'HOW_WORKS.HENTERPANT.PLAYER' | translate}}</h3>
      <p *ngIf="giPantMode" [innerHTML]="'HOW_WORKS.GIPANT.PLAYER_DESC' | translate"></p>
      <p *ngIf="henterPantMode" [innerHTML]="'HOW_WORKS.HENTERPANT.PLAYER_DESC' | translate"></p>
    </div>
  </div>
  <div class="col-wrap" [ngClass]="{'col-lg-3 col-12': giPantMode, 'col-lg-4 col-12': henterPantMode}">
    <div class="step-wrap step-3">
      <div class="number"><span>03</span></div>
      <h3 class="sub-title" *ngIf="giPantMode"><i class="icon custom-sport-club"></i>{{'HOW_WORKS.GIPANT.SPORT_CLUB' | translate}}</h3>
      <h3 class="sub-title" *ngIf="henterPantMode"><i class="icon custom-sport-club"></i>{{'HOW_WORKS.HENTERPANT.SPORT_CLUB' | translate}}</h3>
      <p *ngIf="giPantMode" [innerHTML]="'HOW_WORKS.GIPANT.SPORT_CLUB_DESC' | translate"></p>
      <p *ngIf="henterPantMode" [innerHTML]="'HOW_WORKS.HENTERPANT.SPORT_CLUB_DESC' | translate"></p>
    </div>
  </div>
</div>
